import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import BrandedLoader from '../components/BrandedLoader';

const FeatureRoute = ({ children, anyOf = [], moduleFlags = [], fallback = '/dashboard/settings#business-modules' }) => {
  const location = useLocation();
  const role = useSelector((state) => state.auth.user?.role);
  const features = useSelector((state) => state.ui.subscriptionFeatures);
  const entitlementStatus = useSelector((state) => state.ui.subscriptionStatus);
  const shop = useSelector((state) => state.shop.profile);
  const shopStatus = useSelector((state) => state.shop.status);

  // Operators use duty-scoped staff APIs; they do not load owner subscription state.
  if (role === 'SHOP_OPERATOR' && location.pathname.replace(/\/$/, '') === '/dashboard/kitchen') return <Outlet />;

  if (entitlementStatus === 'idle' || (!shop && ['idle', 'loading'].includes(shopStatus))) {
    return <BrandedLoader message="Checking package access..." />;
  }

  const featureAllowed = !anyOf.length || anyOf.some((feature) => features?.includes(feature));
  const moduleAllowed = !moduleFlags.length || moduleFlags.some((flag) => shop?.[flag] === true);

  if (!featureAllowed || !moduleAllowed) {
    return <Navigate to={fallback} replace state={{ accessDeniedFrom: location.pathname }} />;
  }

  return children || <Outlet />;
};

export default FeatureRoute;
